import type { SearchAddressResult } from '$lib/components/search/address/types';

let selectedAddress = $state.raw<SearchAddressResult | null>(null);

export function getSelectedAddress() {
	return selectedAddress;
}

export function setSelectedAddress(value: SearchAddressResult | null) {
	selectedAddress = value;
}
